export const clampSrcSetWidths = (widths: number[], nativeWidth: number | undefined): number[] => {
  if (!nativeWidth) return widths;

  const clamped = widths.filter(width => width <= nativeWidth);
  const truncated = clamped.length < widths.length;

  if (!truncated) return clamped;
  if (clamped.includes(nativeWidth)) return clamped;

  return [...clamped, nativeWidth];
};
